import { NavItem } from '@tran-monorepo/interfaces';

export const PRIMARY_NAV_ITEMS: NavItem[] = [
    { label: 'nav.primary.home', route: '/' },
    { label: 'nav.primary.myApplications', route: '/applications' },
    { label: 'nav.primary.createApplication', route: '/apply' }
] as const;

export const SECONDARY_NAV_ITEMS: NavItem[] = [
    { label: 'nav.secondary.faq', route: '/faq' },
    { label: 'nav.secondary.contact', route: 'mailto:transformationsfonds.de@siemens.com', external: true }
] as const;
